import {
    activarProductoInventarioHttp,
    createInventarioHttp,
    desactivarProductoInventarioHttp,
    editarProductoInventarioHttp,
    generarQrProductoHttp,
    generarQrProductosHttp,
} from "actions/inventario";
import type {
    QrProducto,
    ResultadoQrMasivo,
    ValoresFormularioInventario,
} from "../types/catalogoInventario.types";
import { normalizarQr, normalizarResultadoQrMasivo } from "./catalogoInventarioNormalizar.utils";

const entero = (valor: string): number => {
    const n = Number(valor);
    return Number.isFinite(n) ? n : 0;
};

const extraerData = (respuesta: unknown): unknown =>
    respuesta && typeof respuesta === "object" && "data" in respuesta
        ? (respuesta as { data: unknown }).data
        : respuesta;

const camposComunes = (v: ValoresFormularioInventario, idUsuario: number) => ({
    clave: v.clave.trim(),
    nombre: v.nombre.trim(),
    precio: entero(v.precio),
    id_unidad_medida: entero(v.id_unidad_medida),
    id_categoria: entero(v.id_categoria),
    id_ubicacion: entero(v.id_ubicacion),
    id_tipo_producto: entero(v.id_tipo_producto),
    maximos: entero(v.maximos),
    minimos: entero(v.minimos),
    punto_reorden: entero(v.punto_reorden),
    id_usuario: idUsuario,
});

export const crearProductoInventario = (
    valores: ValoresFormularioInventario,
    idUsuario: number,
    proveedores: number[]
) =>
    createInventarioHttp({
        ...camposComunes(valores, idUsuario),
        cantidad: entero(valores.cantidad),
        proveedores,
    });

export const editarProductoInventario = (
    idInventario: number,
    valores: ValoresFormularioInventario,
    idUsuario: number
) =>
    editarProductoInventarioHttp({
        id_inventario: idInventario,
        ...camposComunes(valores, idUsuario),
    });

export const activarProductoInventario = (idInventario: number) =>
    activarProductoInventarioHttp({ id_inventario: idInventario });

export const desactivarProductoInventario = (idInventario: number) =>
    desactivarProductoInventarioHttp({ id_inventario: idInventario });

/** Un producto: regresa su QR (el backend solo lo genera la primera vez) */
export const generarQrProducto = async (idInventario: number, idUsuario: number): Promise<QrProducto> => {
    const respuesta = await generarQrProductoHttp({ id_inventario: idInventario, id_usuario: idUsuario });
    const qr = normalizarQr(extraerData(respuesta));
    if (!qr) throw new Error("La respuesta del QR no es válida.");
    return qr;
};

/** Varios productos a la vez. */
export const generarQrProductos = async (
    idsInventario: number[],
    idUsuario: number
): Promise<ResultadoQrMasivo> => {
    const respuesta = await generarQrProductosHttp({ ids_inventario: idsInventario, id_usuario: idUsuario });
    return normalizarResultadoQrMasivo(extraerData(respuesta));
};
